<template>
  <HeadComponent />

  <slot />

  <FooterComponent :country="country" />
</template>

<script>
import HeadComponent from './Components/Head.vue';
import FooterComponent from './Components/Footer.vue';

export default {
  components: {
    HeadComponent,
    FooterComponent,
  },

  props: {
    country: {
      type: String,
      required: true,
    },
  },
};
</script>
